import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-isomasters-popup',
  templateUrl: './isomasters-popup.component.html',
  styleUrls: ['./isomasters-popup.component.scss'],
})
export class IsomastersPopupComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
